import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import ImgView from 'components/common/FileController/ImgView';
import PGoodsModal from './PGoodsModal';
import { notification, Button, Descriptions, Input, Checkbox, Table, Select, Divider } from 'antd';

@inject(({ goodsJobStore }) => ({ 
  detailData: goodsJobStore.detailData,
  onViewMode : goodsJobStore.onViewMode,
  disGoodsJobDetail: goodsJobStore.disGoodsJobDetail,
  merGoodsJobList: goodsJobStore.merGoodsJobList,
  delGoodsJobList: goodsJobStore.delGoodsJobList,
}))
@observer
class GoodsJobDetail extends Component {
  state = {
    gjPGdCd: '',
    gdJobList: [],

    modalOpen: false
  };

  UNSAFE_componentWillMount() {
    if (this.props.detailData !== null) {
      this.setState({
        gjPGdCd: (this.props.detailData.gjPGdCd !== undefined && this.props.detailData.gjPGdCd !== null) 
          ? this.props.detailData.gjPGdCd : '', 
        gdJobList: (this.props.detailData.gdJobList !== undefined && this.props.detailData.gdJobList !== null) 
          ? this.props.detailData.gdJobList : [],
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.detailData !== this.props.detailData) {
      if (nextProps.detailData === null) {
        this.setState({
          gjPGdCd: '', 
          gdJobList: [],
        });
      } else {
        this.setState({
          gjPGdCd: (nextProps.detailData.gjPGdCd !== undefined && nextProps.detailData.gjPGdCd !== null) 
            ? nextProps.detailData.gjPGdCd : '', 
          gdJobList: (nextProps.detailData.gdJobList !== undefined && nextProps.detailData.gdJobList !== null) 
            ? nextProps.detailData.gdJobList : [],
        });
      }
    }
  }

  handleSave = () => {
    const { gjPGdCd, gdJobList } = this.state;
    if (gjPGdCd === '') {
      notification.warning({placement: 'bottomLeft', message: `상품군을 선택해주세요.`, duration: 2});
      return false;
    }

    // 빈값 체크 Start
    let emptyChk = false;
    let emptyChkIdx = 0;
    gdJobList.map((item, idx)=>{
      return (
        ((item.gjJobCd === "") && emptyChk === false) &&
        (emptyChk = true, emptyChkIdx = idx + 1)
      );
    });

    if (emptyChk === true) {
      notification.warning({placement: 'bottomLeft', message: `${emptyChkIdx}번째 직무를 선택하세요.`, duration: 2});
      return false;
    }
    // 빈값 체크 End
    
    // 중복체크 Start
    let boolChk = false;
    let ChkIdx1 = 0;
    let ChkIdx2 = 0;
    gdJobList.map((item, idx)=>{ return(
      gdJobList.map((chkItem, chkIdx)=>{
        return( (item.gjJobCd === chkItem.gjJobCd && boolChk === false && idx !== chkIdx) &&
          (boolChk = true, ChkIdx1 = idx + 1, ChkIdx2 = chkIdx + 1)
        )
      })
    )});

    if (boolChk === true) {
      notification.warning({placement: 'bottomLeft', message: `${ChkIdx1}번째,${ChkIdx2}번째의 직무가 중복됩니다.`, duration: 2});
      return false;
    }
    // 중복체크 End

    let vDelArr = [];
    let vMerArr = [];
    if (this.props.detailData !== null && this.props.detailData.gdJobList !== undefined && this.props.detailData.gdJobList !== null) {
      this.props.detailData.gdJobList.map((orgItme)=>{
        let boolDel = true;
        return(
          gdJobList.map((chgItem)=>{ return (
            (orgItme.gjJobCd === chgItem.gjJobCd) &&
            (vMerArr.push(chgItem), boolDel = false)
            
          )}),
          (boolDel === true) && vDelArr.push(orgItme)
        )
      });
    }

    gdJobList.map((chgItem)=>{
      let boolAdd = true;
      return (
        (this.props.detailData !== null && this.props.detailData.gdJobList !== undefined && this.props.detailData.gdJobList !== null) &&
          (this.props.detailData.gdJobList.map((orgItme)=>{return (
            (orgItme.gjJobCd === chgItem.gjJobCd) && (boolAdd = false)
          )})),
        (boolAdd === true) && vMerArr.push(chgItem)
      )
    });

    // console.log("vMerArr", vMerArr);
    // console.log("vDelArr", vDelArr);

    if (vMerArr.length > 0) {
      this.props.merGoodsJobList(vMerArr);
    }
    if (vDelArr.length > 0 ) {
      this.props.delGoodsJobList(vDelArr);
    }
    
  };

  handleReset = () => {
    const { detailData } = this.props;
    this.setState({
      gdJobList: (detailData !== null && detailData.gdJobList !== undefined && detailData.gdJobList !== null)
              ? detailData.gdJobList : []
    });
  };

  handleAdd = () => {
    let newData = {
      RNUM: "new" + Date.now(),
      gjPGdCd: this.state.gjPGdCd,
      gjJobCd: '',
      gjJobNm: '',
      gjGdCnt: 1,
      gjUseDate: 2,
    };
    this.setState({
      gdJobList: [
        ...this.state.gdJobList,
        newData,
      ]
    });
  };
  
  handleDelete = key => {
    this.setState({
      gdJobList: this.state.gdJobList.filter(item => item.RNUM !== key)
    });
  };

  handleChange = (type, name, item, record, index) => {
    const funcChange = (value) => {
      const newData = [...this.state.gdJobList];
      newData.splice(index, 1, {
        ...record,
        [name]:value,
      });
      this.setState({ gdJobList: newData });
    };

    if (type === 'Input') {
      return (
        <Input
          disabled={(this.props.ceType === process.env.REACT_APP_TYPE_YUJIN) ? false : true}
          value={item}
          onChange={(e)=>funcChange(e.target.value)}
          style={{ width: 200, marginRight: 8 }}
        />
      )
    } else if (type === 'InputNumber') {
      return (
        <Input
          disabled={(this.props.ceType === process.env.REACT_APP_TYPE_YUJIN) ? false : true}
          value={item}
          onChange={(e)=>{
            let value = e.target.value;
            value = value.toString().replace(/[^0-9]/g, "");
            funcChange(value);
          }}
          style={{ width: 200, marginRight: 8 }}
        />
      )
    } else if (type === 'Checkbox') {
      return (
        <Checkbox
          disabled={(this.props.ceType === process.env.REACT_APP_TYPE_YUJIN) ? false : true}
          checked={item === 'Y' ? true : false}
          onChange={(e)=>funcChange(e.target.checked ? "Y" : "N")}
        />
      )
    } else if (type === 'Select') {
      return (
        <Select
          disabled={(this.props.ceType === process.env.REACT_APP_TYPE_YUJIN) ? false : true}
          style={{ width: '100%' }}
          value={item}
          onChange={(value)=>funcChange(value)}
        >
          {this.props.jobList.map(item=>{
            return(
            <Select.Option key={item.jobCd}>{item.jobNm}</Select.Option>
            )
          })}
        </Select>
      )
    }
  };

  render() {
    const { ceType, detailData, onViewMode, disGoodsJobDetail } = this.props;
    const { gdJobList, modalOpen } = this.state;
    const columns = [
      { title: '삭제', dataIndex: '', key: '', width: '20%', align: 'center',
        render: (item, record) => { return(
          <Fragment key={record.RNUM}>
            <Button
              onClick={() => this.handleDelete(record.RNUM)}
            >삭제</Button>
          </Fragment>
        )}
      },
      { title: '이용가능 직무', dataIndex: 'gjJobCd', key: 'gjJobCd', width: '25%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('Select', 'gjJobCd', item, record, index)
        )}
      },
      { title: () => { return(
          <Fragment>
            최대구입 가능 수량
            <br />
            <span style={{ color: 'red' }}>※제한이 없을 경우 1000개 이상으로 입력하세요</span>
          </Fragment>
        )}, dataIndex: 'gjGdCnt', key: 'gjGdCnt', width: '30%', align: 'center',
        render: (item, record, index) => { return(
          <Fragment>
          {this.handleChange('InputNumber', 'gjGdCnt', item, record, index)} 개
          </Fragment>
        )}
      },
      { title: '최대구입 사용 기한', dataIndex: 'gjUseDate', key: 'gjUseDate', width: '25%', align: 'center',
        render: (item, record, index) => { return(
          <Fragment>
          {this.handleChange('InputNumber', 'gjUseDate', item, record, index)} 년
          </Fragment>
        )}
      }
    ];
    const columnsGoods = [
      { title: '사진', dataIndex: 'imgUrl', width: '20%', align: 'center',
        render: (item, record) => { return(
          record.gdImgUrlInfo_fileId !== undefined && record.gdImgUrlInfo_fileId !== null &&
          <ImgView
            fileInfo={{
              fileId: record.gdImgUrlInfo_fileId,
              fileName: record.gdImgUrlInfo_fileName,
              physicalName: record.gdImgUrlInfo_physicalName,
              serverSubPath: record.gdImgUrlInfo_serverSubPath,
            }}
            width={50}
            height={50}
            detailFileInfo={{
              fileId: record.gdDetailUrlInfo_fileId,
              fileName: record.gdDetailUrlInfo_fileName,
              physicalName: record.gdDetailUrlInfo_physicalName,
              serverSubPath: record.gdDetailUrlInfo_serverSubPath,
            }}
          />
        )}
      },
      { title: '상품명', dataIndex: 'gdNm', width: '40%', align: 'center' },
      { title: '성별', dataIndex: 'gdSex', width: '20%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item === "M" && <Fragment>남</Fragment>}
            {item === "F" && <Fragment>여</Fragment>}
            {item === "A" && <Fragment>공용</Fragment>}
          </Fragment>
        )}
      },
      { title: '판매가', dataIndex: 'gdPrice', width: '20%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== "" && item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      }
    ];
    return (
      <Fragment>
        <div className="button-group">
          <h2>상품 이용 정보</h2>
          <div className="button-right">
            <ul>
              <li><Button type="primary" onClick={()=>onViewMode('list')}>목록</Button></li>
            </ul>
          </div>
        </div>
        <div className="table_th_W">
          <Descriptions bordered>
            <Descriptions.Item label="상품군 *" span={3}>
              <Button 
                type="primary"
                style={{ marginRight: 8 }}
                onClick={()=>this.setState({modalOpen : true})}
              >상품군선택</Button>
              {(detailData !== null && detailData.gjPGdCdName !== undefined && detailData.gjPGdCdName !== null && detailData.gjPGdCdName)}
            </Descriptions.Item>
          </Descriptions>
        </div>
        <Divider />

        <Table
          rowKey={(record)=>record.gdCd}
          columns={columnsGoods}
          dataSource={(detailData !== null && detailData.pGdCdGoodsList !== undefined && detailData.pGdCdGoodsList !== null) ? detailData.pGdCdGoodsList : []}
          pagination={false}
          scroll={{ y: 400 }}
        />

        <Divider />

        <div className="button-group">
          <h2>▶ 이용 직무</h2>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span style={{ color: 'red' }}>{process.env.REACT_APP_WARNING}</span>
          {(ceType === process.env.REACT_APP_TYPE_YUJIN) &&
          (detailData !== null && detailData.gjPGdCd !== undefined && detailData.gjPGdCd !== null) &&
            <div className="button-right">
              <ul>
                <li><Button onClick={this.handleAdd}>직무추가</Button></li>
                <li><Button onClick={this.handleReset}>초기화</Button></li>
                <li><Button type="primary" onClick={this.handleSave}>저장</Button></li>
              </ul>
            </div>
          }
        </div>
        {(detailData !== null && detailData.gjPGdCd !== undefined && detailData.gjPGdCd !== null)
        ? <Table
            rowKey={(record)=>record.RNUM}
            columns={(ceType === process.env.REACT_APP_TYPE_YUJIN) 
                    ? columns : columns.slice(1, columns.length)} 
            dataSource={gdJobList}
            pagination={false}
          />
        : <Fragment>상품군을 먼저 선택해주세요.</Fragment>
        }
        <PGoodsModal
          crudYn={false}
          modalOpen={modalOpen}
          modalClose={()=>this.setState({modalOpen: false})}
          setData={(data)=>disGoodsJobDetail({gjPGdCd: data.groupCd, gjPGdCdName: data.groupNm})}
        />
      </Fragment>
    );
    
  }
}

export default withRouter(GoodsJobDetail);
